import { ActionTypesRules, rulesDetailPaneInitialState } from './constants';
import {
  RuleSpecLookupsData,
  RulesHeaderData,
  RulesInitialStateType,
  UserColumnConfigType,
} from './types';

const initialState: RulesInitialStateType = {
  rulesGridData: [],
  rulesAdvancedSearchGridData: [],
  isRulesLoading: false,
  showRulesGrid: false,
  showRulesAdvSearchResults: false,
  isDetailPaneLoading: false,
  rulesHeaderData: {} as RulesHeaderData,
  isRulesHeaderLoading: false,
  ruleSpecCategories: [],
  ruleSpecSubCategories: [],
  isRuleCategoriesLoading: false,
  isRuleSpecLookupsLoading: false,
  ruleSpecLookupsData: {} as RuleSpecLookupsData,
  ruleAttachmentInfoData: [],
  isRuleAttachmentInfoLoading: false,
  userColumnRedux: {} as UserColumnConfigType,
  isUserColumnRedux: false,
  isResetRuleGrid: false,
  isRuleHistoryDataLoading: false,
  ruleHistoryData: [],
  breadCrumbItemsDetailPane: [],
  disabledColumns: [],
};

const rulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypesRules.SET_RULE_SPECS_GRID_DATA:
      return {
        ...state,
        rulesGridData: action.gridData,
      };
    case ActionTypesRules.TOGGLE_RULES_ADVANCED_SEARCH_GRID:
      return {
        ...state,
        showRulesAdvSearchResults: action.showRulesAdvSearchResults,
      };
    case ActionTypesRules.TOGGLE_SHOW_RULES_GRID:
      return {
        ...state,
        showRulesGrid: action.showGrid,
      };
    case ActionTypesRules.TOGGLE_RULE_ATTACHMENTS_LOADING:
      return {
        ...state,
        isRuleAttachmentInfoLoading: action.isLoading,
      };
    case ActionTypesRules.SET_RULE_ATTACHMENT_INFO_DATA:
      return {
        ...state,
        ruleAttachmentInfoData: action.data,
      };
    case ActionTypesRules.TOGGLE_RULES_LOADING:
      return {
        ...state,
        isRulesLoading: action.isLoading,
      };
    case ActionTypesRules.TOGGLE_DETAIL_PANE_LOADING:
      return {
        ...state,
        isDetailPaneLoading: action.isDetailPaneLoading,
      };
    case ActionTypesRules.TOGGLE_RULES_HEADER_LOADING:
      return {
        ...state,
        isRulesHeaderLoading: action.isRulesHeaderLoading,
      };
    case ActionTypesRules.SET_RULES_HEADER_DATA:
      return {
        ...state,
        rulesHeaderData: action.headerData,
      };
    case ActionTypesRules.CLEAR_RULES_DETAIL_PANE_REDUX_DATA:
      return {
        ...state,
        ...rulesDetailPaneInitialState,
      };
    case ActionTypesRules.SET_RULE_SPEC_CATEGORIES:
      return {
        ...state,
        ...action.response,
      };
    case ActionTypesRules.TOGGLE_RULES_CATEGORIES_LOADING:
      return {
        ...state,
        isRuleCategoriesLoading: action.isLoading,
      };
    case ActionTypesRules.TOGGLE_RULE_SPEC_LOOKUPS_LOADING:
      return {
        ...state,
        isRuleSpecLookupsLoading: action.isLoading,
      };
    case ActionTypesRules.SET_RULE_SPEC_LOOKUPS_DATA:
      return {
        ...state,
        ruleSpecLookupsData: action.lookupsData,
      };
    case ActionTypesRules.SET_USER_CONFIG_REDUX:
      return {
        ...state,
        userColumnRedux: action.payload,
        isUserColumnRedux: true,
      };
    case ActionTypesRules.TOGGLE_RESET_RULE_GRID:
      return {
        ...state,
        isResetRuleGrid: action.isResetRuleGrid,
      };
    case ActionTypesRules.SET_RULE_HISTORY_DATA:
      return {
        ...state,
        ruleHistoryData: action.data,
      };
    case ActionTypesRules.TOGGLE_IS_RULE_HISTORY_DATA_LOADING:
      return {
        ...state,
        isRuleHistoryDataLoading: action.isLoading,
      };
    case ActionTypesRules.SET_RULE_SPECS_ADV_SEARCH_GRID_DATA:
      return {
        ...state,
        rulesAdvancedSearchGridData: action.gridData,
      };
    case ActionTypesRules.SET_RULE_DETAIL_PANE_BREADCRUMB_ITEMS:
      return {
        ...state,
        breadCrumbItemsDetailPane: action.breadCrumbItems,
      };
    case ActionTypesRules.SET_DISABLED_COLUMNS:
      return {
        ...state,
        disabledColumns: action.disabledColumns,
      };
    default:
      return state;
  }
};

export default rulesReducer;
